(function() {
 
  function activateTab(tab) {
    var targetId = tab.dataset.tab;
    document.querySelectorAll('.hrl-tab').forEach(function(t) {
      t.classList.remove('hrl-tab--active');
      t.setAttribute('aria-selected', 'false');
    });
    document.querySelectorAll('.hrl-panel').forEach(function(p) {
      p.classList.remove('hrl-panel--active');
    });
    tab.classList.add('hrl-tab--active');
    tab.setAttribute('aria-selected', 'true');
    var panel = document.getElementById('hrl-panel-' + targetId);
    if (panel) panel.classList.add('hrl-panel--active');
  }
 
  function updateHash(ritualName, levelName) {
    var hash = ritualName + (levelName ? '-' + levelName : '');
    history.replaceState(null, '', window.location.pathname + '#' + hash);
  }
 
  function getActiveLevel(panel) {
    if (!panel) return 'absolute';
    var activeBtn = panel.querySelector('.hrl-version-btn--active');
    return activeBtn ? (activeBtn.dataset.version || 'absolute') : 'absolute';
  }
 
  /* -- TABS -- */
  document.querySelectorAll('.hrl-tab').forEach(function(tab) {
    tab.addEventListener('click', function() {
      activateTab(tab);
      var ritualName = tab.textContent.trim().toLowerCase();
      var panel = document.getElementById('hrl-panel-' + tab.dataset.tab);
      updateHash(ritualName, getActiveLevel(panel));
    });
  });
 
  /* -- VERSION BUTTONS -- */
  document.querySelectorAll('.hrl-version-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var pid = btn.dataset.product;
      var price = btn.dataset.price;
      var variantId = btn.dataset.variant;
      var bundleImg = parseInt(btn.dataset.bundleImg || '0');
      var isEssential = btn.dataset.isEssential === 'true';
 
      var panel = document.getElementById('hrl-panel-' + pid);
      if (panel) {
        panel.querySelectorAll('.hrl-version-btn').forEach(function(b) {
          b.classList.remove('hrl-version-btn--active');
        });
      }
      btn.classList.add('hrl-version-btn--active');
 
      var priceEl = document.querySelector('[data-price="' + pid + '"]');
      if (priceEl && price) priceEl.textContent = price;

      var curatedEl = document.querySelector('.hrl-curated-number[data-product="' + pid + '"]');
      if (curatedEl) {
        curatedEl.textContent = isEssential ? curatedEl.dataset.essentialText : curatedEl.dataset.absoluteText;
      }

      document.querySelectorAll('[data-variant-input="' + pid + '"]').forEach(function(input) {
        input.value = variantId;
      });
      document.querySelectorAll('.hrl-payment-variant-input[data-product="' + pid + '"]').forEach(function(input) {
        input.value = variantId;
      });
 
      goToSlide(pid, bundleImg, false);
 
      if (panel) {
        panel.querySelectorAll('.hrl-product-li--absolute-only').forEach(function(li) {
          li.classList.toggle('hrl-product-li--greyed', isEssential);
        });
        if (isEssential) {
          var activeItem = panel.querySelector('.hrl-product-item--active');
          if (activeItem && activeItem.closest('.hrl-product-li--absolute-only')) {
            panel.querySelectorAll('.hrl-product-item').forEach(function(i) { i.classList.remove('hrl-product-item--active'); });
          }
        }
      }
 
      /* Update hash when level changes */
      var activeTab = document.querySelector('.hrl-tab--active');
      if (activeTab) {
        updateHash(activeTab.textContent.trim().toLowerCase(), btn.dataset.version);
      }
    });
  });
 
  /* -- AUTO-ACTIVATE FROM HASH OR DEFAULT TO INFINITY/ABSOLUTE -- */
  (function() {
    var hash = window.location.hash.replace('#', '').toLowerCase();
    var parts = hash.split('-');
    var ritual = parts[0] || 'infinity';
    var level  = parts[1] || 'absolute';
 
    var matched = null;
    document.querySelectorAll('.hrl-tab').forEach(function(tab) {
      if (tab.textContent.trim().toLowerCase() === ritual) matched = tab;
    });
 
    if (matched) {
      activateTab(matched);
      var panel = document.getElementById('hrl-panel-' + matched.dataset.tab);
      if (panel) {
        panel.querySelectorAll('.hrl-version-btn').forEach(function(btn) {
          if (btn.dataset.version && btn.dataset.version.toLowerCase() === level) {
            btn.click();
          }
        });
      }
    }
 
    /* Set hash on first load so URL is always meaningful */
    var activeTab = document.querySelector('.hrl-tab--active');
    if (activeTab) {
      var activePanel = document.getElementById('hrl-panel-' + activeTab.dataset.tab);
      updateHash(activeTab.textContent.trim().toLowerCase(), getActiveLevel(activePanel));
    }
  })();
 
  /* -- GALLERY -- */
  function goToSlide(galleryId, index, skipProductSync) {
    var slides = document.querySelectorAll('.hrl-gallery-slide[data-gallery="' + galleryId + '"]');
    var dots   = document.querySelectorAll('.hrl-gallery-dot[data-gallery="' + galleryId + '"]');
    var total  = slides.length;
    if (total === 0) return;
    var n = ((index % total) + total) % total;
    slides.forEach(function(s, i) { s.classList.toggle('hrl-gallery-slide--active', i === n); });
    dots.forEach(function(d, i)   { d.classList.toggle('hrl-gallery-dot--active',   i === n); });
    if (!skipProductSync) {
      document.querySelectorAll('.hrl-product-item[data-product="' + galleryId + '"]').forEach(function(item) {
        item.classList.toggle('hrl-product-item--active', parseInt(item.dataset.imgIndex) === n);
      });
    }
  }
 
  document.querySelectorAll('.hrl-gallery-arrow--next').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var gid = btn.dataset.gallery;
      var active = document.querySelector('.hrl-gallery-slide--active[data-gallery="' + gid + '"]');
      goToSlide(gid, (active ? parseInt(active.dataset.index) : 0) + 1);
    });
  });
 
  document.querySelectorAll('.hrl-gallery-arrow--prev').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var gid = btn.dataset.gallery;
      var active = document.querySelector('.hrl-gallery-slide--active[data-gallery="' + gid + '"]');
      goToSlide(gid, (active ? parseInt(active.dataset.index) : 0) - 1);
    });
  });
 
  document.querySelectorAll('.hrl-gallery-dot').forEach(function(dot) {
    dot.addEventListener('click', function() {
      goToSlide(dot.dataset.gallery, parseInt(dot.dataset.index));
    });
  });
 
  document.querySelectorAll('.hrl-product-item').forEach(function(item) {
    item.addEventListener('click', function() {
      var pid = item.dataset.product;
      var imgIndex = parseInt(item.dataset.imgIndex);
      var accKey = pid + '-' + imgIndex;
      var acc = document.querySelector('.hrl-accordion[data-accordion="' + accKey + '"]');
 
      /* Check accordion visibility BEFORE goToSlide changes anything */
      var isAccordionOpen = acc && acc.getAttribute('aria-hidden') === 'false';
 
      goToSlide(pid, imgIndex);
 
      /* Close all accordions in this panel */
      var panel = item.closest('.hrl-panel');
      if (panel) {
        panel.querySelectorAll('.hrl-accordion').forEach(function(a) {
          a.setAttribute('aria-hidden', 'true');
        });
        panel.querySelectorAll('.hrl-accordion-trigger').forEach(function(t) {
          t.setAttribute('aria-expanded', 'false');
        });
        panel.querySelectorAll('.hrl-accordion-body').forEach(function(b) {
          b.style.maxHeight = null;
        });
      }
 
      /* Toggle: open only if it was closed before this click */
      if (!isAccordionOpen && acc) {
        acc.setAttribute('aria-hidden', 'false');
      }
    });
  });
 
  /* Accordion trigger click */
  document.querySelectorAll('.hrl-accordion-trigger').forEach(function(trigger) {
    trigger.addEventListener('click', function() {
      var item = trigger.closest('.hrl-accordion-item');
      var body = item.querySelector('.hrl-accordion-body');
      var isOpen = trigger.getAttribute('aria-expanded') === 'true';
 
      /* Close siblings */
      var accordion = trigger.closest('.hrl-accordion');
      accordion.querySelectorAll('.hrl-accordion-trigger').forEach(function(t) {
        t.setAttribute('aria-expanded', 'false');
      });
      accordion.querySelectorAll('.hrl-accordion-body').forEach(function(b) {
        b.style.maxHeight = null;
      });
 
      /* Toggle clicked */
      if (!isOpen) {
        trigger.setAttribute('aria-expanded', 'true');
        body.style.maxHeight = body.scrollHeight + 'px';
      }
    });
  });
 
  /* -- QTY SELECTOR -- */
  function getQty(pid) {
    var hidden = document.querySelector('.hrl-qty-hidden[data-product="' + pid + '"]');
    return hidden ? parseInt(hidden.value || 1) : 1;
  }
  function setQty(pid, val) {
    var n = Math.max(1, val);
    var hidden = document.querySelector('.hrl-qty-hidden[data-product="' + pid + '"]');
    var display = document.querySelector('.hrl-qty-display[data-product="' + pid + '"]');
    if (hidden) hidden.value = n;
    if (display) display.textContent = n;
  }
 
  document.querySelectorAll('.hrl-qty-plus').forEach(function(btn) {
    btn.addEventListener('click', function() { setQty(btn.dataset.product, getQty(btn.dataset.product) + 1); });
  });
 
  document.querySelectorAll('.hrl-qty-minus').forEach(function(btn) {
    btn.addEventListener('click', function() { setQty(btn.dataset.product, getQty(btn.dataset.product) - 1); });
  });
 
})();
/* ── Ne lire que la vidéo de la diapositive active ── */
(function () {
  'use strict';
  function syncVideos() {
    document.querySelectorAll('.hrl-gallery-slide').forEach(function (slide) {
      var v = slide.querySelector('video');
      if (!v) return;
      if (slide.classList.contains('hrl-gallery-slide--active')) {
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      } else {
        try { v.pause(); } catch (e) {}
        /* Rewind only after the 0.45s cross-fade has finished, so the jump
           back to frame one happens while the slide is already invisible.
           Re-check the class in case the viewer returned in the meantime. */
        if (v._hrlRewind) clearTimeout(v._hrlRewind);
        v._hrlRewind = setTimeout(function () {
          if (slide.classList.contains('hrl-gallery-slide--active')) return;
          try { if (v.currentTime !== 0) v.currentTime = 0; } catch (e) {}
        }, 500);
      }
    });
  }
  function init() {
    syncVideos();
    if (window.MutationObserver) {
      var mo = new MutationObserver(syncVideos);
      document.querySelectorAll('.hrl-gallery').forEach(function (g) {
        mo.observe(g, { attributes: true, attributeFilter: ['class'], subtree: true });
      });
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
